import { render, staticRenderFns } from "./incl-assets.vue?vue&type=template&id=7016425b&scoped=true"
import script from "./incl-assets.vue?vue&type=script&lang=js"
export * from "./incl-assets.vue?vue&type=script&lang=js"
import style0 from "./incl-assets.vue?vue&type=style&index=0&id=7016425b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7016425b",
  null
  
)

export default component.exports